import { lazy } from "react";
import { build } from "../../tools/ConfigBuilder";

const transferFundsPath = {
	path: "/admin/transactions/finance-transfer-funds",
	component: lazy(() => import("./TransactionsStateFinanceTransferFundsPage")),
};

export default build([...(false ? [transferFundsPath] : [])]); // TODO: WALLET_FEATURE gk
